import { useRouter } from 'next/router';
import { getLocaleContent } from '@helper/locale-content.js';
import BreadcrumbNav from '@components/common/BreadcrumbNav';
import { HomeOutlined } from '@ant-design/icons';

export default function ServiceProductNav() {
    const { locale } = useRouter();

    const breadcrumbItems = [
        { label: '', href: '/', icon: <HomeOutlined /> },
        {
            label: getLocaleContent(locale, 'page.service.nav-title'),
            href: '/san-pham-dich-vu',
            color: '#006940',
        },
    ];

    return (
        <div>
            <BreadcrumbNav items={breadcrumbItems} />
        </div>
    );
}


